import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { UiUser, UsersSearchParams } from "src/app/shared/models/ui-user.model";
import { SharedService } from "src/app/shared/services/shared.service";
import { ChatService } from "src/app/shared/services/chat.service";
import { ChatTask } from "src/app/shared/models/chat.model";
import { UsersService } from "src/app/shared/services/users.service";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { DataElement } from "src/app/shared/models/common";
import { DataService } from "src/app/shared/services/data.service";
import { AuthService } from "src/app/shared/services/auth.service";
import { Store } from "@ngrx/store";
import {
  CREATED_CHAT_TASK,
  REQUEST_DASHBOARD_REFRESH,
} from "src/app/shared/ngrx/ngrx-actions";
import { Subject } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import {
  taskUsersList,
  chatTaskStatusList,
  currentOrder,
} from "src/app/shared/ngrx/ngrx-selectors";
import { InputWrapComponent } from "src/app/shared/components/ui/input-wrap.component";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DatePickerModule } from "primeng/datepicker";
import { SelectModule } from "primeng/select";
import { SpinnerComponent } from "src/app/shared/components/ui/spinner/spinner.component";

@Component({
  selector: "edit-chat-task",
  templateUrl: "./edit-chat-task.component.html",
  styleUrls: ["./edit-chat-task.component.scss"],
  imports: [
    TranslateModule,
    InputWrapComponent,
    CommonModule,
    FormsModule,
    DatePickerModule,
    SelectModule,
    SpinnerComponent,
  ],
  standalone: true,
})
export class EditChatTaskComponent implements OnInit {
  @Input() task: ChatTask;
  @Output() onCancel = new EventEmitter();

  calLocale = {};
  saving: boolean;
  destroy$ = new Subject();
  taskUsersList: UiUser[];
  statusList: DataElement[];

  constructor(
    private readonly store: Store,
    private usersService: UsersService,
    private chatService: ChatService,
    private dataService: DataService,
    private sharedService: SharedService,
    private translateService: TranslateService,
    private authService: AuthService
  ) {
    this.translateService.get("calLocale").subscribe((data) => {
      this.calLocale = data;
    });
  }

  ngOnInit(): void {
    this.store
      .select(taskUsersList)
      .pipe(takeUntil(this.destroy$))
      .subscribe((sm) => {
        this.taskUsersList = sm;
      });

    this.store
      .select(chatTaskStatusList)
      .pipe(takeUntil(this.destroy$))
      .subscribe((sm) => {
        this.statusList = sm;
      });

    if (this.taskUsersList.length == 0) {
      this.getTaskUsersList();
    } else {
      this.setOwnerUser();
    }

    if (this.statusList.length == 0) {
      this.getStatusList();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(1);
  }

  getTaskUsersList() {
    let userParams = new UsersSearchParams();
    userParams.rangeFrom = 0;
    userParams.rangeTo = 100;
    userParams.taskUsersSw = true;

    if (this.authService.currentUser.org == "LAB") {
      userParams.org = "LAB";
    } else if (this.authService.currentUser.org == "PLANT") {
      userParams.org = "PLANT";
      userParams.plant = this.authService.currentUser.plant;
    }

    this.usersService
      .getUsers(userParams, false, true, true)
      .subscribe((data) => {
        this.setOwnerUser();
      });
  }

  setOwnerUser() {
    if (!this.task.taskId) {
      this.task.owner = this.taskUsersList.find(
        (u) => u.userId == this.authService.currentUser.userId
      );
    } else {
      this.task.owner = this.taskUsersList.find(
        (u) => u.userId == this.task.owner.userId
      );
    }
  }

  getStatusList() {
    this.dataService.getTaskStatusList().subscribe();
  }

  save() {
    this.saving = true;
    this.store
      .select(currentOrder)
      .pipe(take(1))
      .subscribe((currentOrder) => {
        this.chatService
          .createUpdateChatTask(currentOrder, this.task)
          .subscribe(
            (data) => {
              this.saving = false;
              this.closePanel();

              this.store.dispatch(
                CREATED_CHAT_TASK({
                  data: this.task,
                })
              );

              this.store.dispatch(REQUEST_DASHBOARD_REFRESH());
            },
            (error) => {
              this.saving = false;
              this.sharedService.alertError(error);
            }
          );
      });
  }

  saveEnabled() {
    return this.task.owner;
  }

  public closePanel() {
    this.onCancel.emit();
  }
}
